import axios from 'axios';

export async function getCampaigns(count, page = 1, startLimit = 0) {
    $('#loader-container').show();
    let paramsPage = {};
    paramsPage.count = count;
    if (startLimit > 0) {
        paramsPage.startLimit = startLimit;
    }

    return new Promise(async (resolve, reject) => {
        const dataResponse = await axios.post('/mycampaigns/get-campaigns-portfolio', {
            params: paramsPage
        }).then((response) => {
            if (response.data.response != 'denied') {
                const dataList = response.data.response;
                if (count == true) {
                    resolve(dataList['campaigns'])
                } else {
                    const resultMessage = {
                        type: response.data.type,
                        message: response.data.message,
                    };
                    const dataResult = {
                        campaigns: dataList['campaigns'],
                        page: page,
                        resultMessage : resultMessage,
                        siteUrl: dataList['siteURL'],
                    };

                    resolve(dataResult)
                }
                $('#loader-container').hide();
            } else {
                window.location.href = '/login';
            }
        });
    });
}
